




































































































import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import formulaireReponseMixin from './formulaireReponseMixin'
import mixins from 'vue-typed-mixins'

export default mixins(formulaireReponseMixin, mobileTypeMixin).extend({})
